import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";

const getTableOrders = () => {
    return axios.get(`method/restaurant_management.api.get_floor_data`);
};

export const useGetTableOrders = () => {
    return useQuery(
        ["getTableOrdersData"],
        async () => {
            const { data } = await getTableOrders();
            return data;
        },
        {
            refetchOnMount: true,
            refetchOnReconnect: true,
            refetchOnWindowFocus: true,
        }
    );
};

export const useMoveOrderItems = () => {
    return useMutation(async ({ items, orderId, destinationTable, client }) => {
        const args = {
            items: items,
            destinationTable,
            client,
        };

        const params = {
            model: `Table Order`,
            name: orderId,
            method: `divide`,
            args: JSON.stringify(args),
        };
        const data = await axios.post(
            `method/frappe_helper.api.call`,
            params
        );

        return data;
    });
};

//move_table_orders
